function ArrowUp(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.8.2a8.8 8.8 0 100 17.6A8.8 8.8 0 008.8.2zm3.265 8.545a.88.88 0 01-1.241 0L9.68 7.6v4.919a.88.88 0 11-1.76 0V7.6L6.785 8.746a.88.88 0 01-1.241-1.241l2.64-2.64a.88.88 0 011.24 0l2.64 2.64a.88.88 0 010 1.24z"
        fill="#1FBC6A"
      />
    </svg>
  )
}

export default ArrowUp
